<template>
  <div
    class="video-stream-container"
    :style="style"
    :class="{ 'video-stream-container-with-bar': showSessionBar }"
  >
    <session-bar v-if="showSessionBar" />
    <smileys />
    <div
      v-if="showPlaceholder"
      :style="{ 'background-image': `url(${currentStream.placeholder.url})` }"
      class="video-stream video-stream-placeholder"
      alt="video stream placeholder"
    />
    <template v-else>
      <div
        v-if="currentStream.type == 'vimeo' || currentStream.type == 'youtube'"
        class="video-stream"
        v-html="currentStream.config"
      />
      <div
        v-else-if="currentStream.type == 'livebox'"
        id="video-stream"
        class="video-stream"
      />
      <template v-else-if="currentStream.type == 'avm_cdn77'">
        <iframe
          v-if="cdnSecureUrl1 !== null || cdnSecureUrl2 !== null"
          :src="cdnUrl"
          class="video-stream"
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowfullscreen
        />
        <v-progress-linear v-else :indeterminate="true" class="ma-0" />
      </template>
      <iframe
        v-if="currentStream.type == 'record'"
        :src="currentStream.config"
        class="video-stream"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SessionBar from '../components/views/SessionBar'
import Smileys from './smileys'

export default {
  components: {
    SessionBar,
    Smileys,
  },
  props: {
    layout: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      cdnSecureUrl1: null,
      cdnSecureUrl2: null,
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      videosConfig: state => state.common.virtual.videosConfig,
      forcedStream: state => state.common.virtual.forcedStream,
      rooms: state => state.common.rooms,
      showSessionBar: state => state.common.virtual.sessionBar.show,
    }),
    currentStream() {
      const { forcedStream, videosConfig, rooms } = this
      if (forcedStream) {
        return forcedStream
      }

      if (this.$route.params.roomId) {
        return videosConfig[this.$route.params.roomId]
      } else {
        return videosConfig[rooms[0].id]
      }
    },
    currentStreamConfig() {
      const { currentStream } = this
      if (!currentStream) {
        return null
      }

      if (currentStream.type == 'avm_cdn77') {
        return JSON.parse(currentStream.config)
      }

      return currentStream.config
    },
    cdnUrl() {
      const {
        currentStream,
        cdnSecureUrl1,
        cdnSecureUrl2,
        currentStreamConfig,
      } = this
      if (!currentStream || currentStream.type != 'avm_cdn77') {
        return null
      }

      let url =
        'https://bradmax.com/client/embed-player/afbbd10ad9c52f72e621e425d395a158d8011c8c_7953?'

      if (cdnSecureUrl1) {
        url += `mediaUrl=${cdnSecureUrl1}&`
      }
      if (cdnSecureUrl2) {
        url += `mediaUrl2=${cdnSecureUrl2}&`
      }

      url += `title=${currentStreamConfig.title}&splashImgUrl=${currentStreamConfig.splashImgUrl}&id=${currentStreamConfig.id}`

      return url
    },
    style() {
      if (this.layout === 'virtualMobile') {
        return { width: '100vw', height: 'calc(100vw/1.77)' }
      }
      return {}
    },
    showPlaceholder() {
      const { currentStream, user } = this

      if (!currentStream) {
        return false
      }

      if (!currentStream.placeholder.show) {
        return false
      }

      if (currentStream.placeholder.badge_types.length > 0) {
        return (
          currentStream.placeholder.badge_types.indexOf(user.badge_type) !== -1
        )
      }

      return true
    },
  },

  mounted() {
    this.loadStream()
  },

  beforeDestroy() {
    this.destroyLiveboxPlayer()
  },

  methods: {
    loadStream() {
      const { currentStream } = this
      let roomId = this.$route.params.roomId
      if (!roomId) {
        roomId = this.rooms[0].id
      }

      if (
        currentStream.type == 'livebox' &&
        this.user &&
        !currentStream.placeholder.show
      ) {
        this.destroyLiveboxPlayer()
        $.getScript(`/js/livebox/${roomId}/${this.user.code}.js`)
      } else if (currentStream.type == 'avm_cdn77') {
        axios.get(`/cdn77/${roomId}`).then(response => {
          this.cdnSecureUrl1 = response.data.secureUrl1
          this.cdnSecureUrl2 = response.data.secureUrl2
        })
      }
    },

    destroyLiveboxPlayer() {
      if (window.liveboxPlayer) {
        liveboxPlayer.destroy()
        liveboxPlayer = null
      }
    },
  },

  watch: {
    currentStream: {
      deep: true,
      handler(newStream, oldStream) {
        if (
          newStream.type != oldStream.type ||
          newStream.config != oldStream.config ||
          (newStream.placeholder.show != oldStream.placeholder.show &&
            !newStream.placeholder.show)
        ) {
          this.loadStream()
        } else if (
          newStream.placeholder.show != oldStream.placeholder.show &&
          newStream.placeholder.show &&
          newStream.type == 'livebox'
        ) {
          this.destroyLiveboxPlayer()
        }
      },
    },
  },
}
</script>
